'use strict';
(function () {
    var peek = document.getElementById('peekBtn');
    var pw = document.getElementById('password');
    peek.addEventListener('click', function () {
        var show = pw.type === 'password';
        pw.type = show ? 'text' : 'password';
        peek.textContent = show ? L.peekAlt : L.peek;
        pw.focus();
    });

    window.Auth = window.Auth || {};
    Auth.strength = function () {
        var v = pw.value || '';
        var sc = 0;
        if (v.length >= 8) sc++;
        if (v.length >= 12) sc++;
        if (/[a-z]/.test(v) && /[A-Z]/.test(v)) sc++;
        if (/\d/.test(v)) sc++;
        if (/[^A-Za-z0-9]/.test(v)) sc++;
        var lvl = v.length === 0 ? 0 : Math.min(4, Math.max(1, sc - 1));
        var w = [0, 25, 50, 75, 100][lvl];
        var c = ['transparent', '#e84c4c', '#e8b84c', '#9ec95a', '#76B82F'][lvl];
        var t = ['', L.pwTooShort, L.pwWeak, L.pwGood, L.pwStrong][lvl];
        var fill = document.getElementById('pwFill');
        var note = document.getElementById('pwNote');
        if (fill) { fill.style.width = w + '%'; fill.style.background = c; }
        if (note) note.textContent = t;
    };

    var emailInput = document.getElementById('email');
    var resetEmail = document.getElementById('resetEmail');
    var resetNote = document.getElementById('resetNote');
    var resetErr = document.getElementById('resetErr');
    var resetSend = document.getElementById('resetSend');

    function switchStep(showReset) {
        document.getElementById('stepPass').classList.toggle('on', !showReset);
        document.getElementById('stepReset').classList.toggle('on', showReset);
        resetNote.classList.remove('show');
        resetErr.classList.remove('show');
    }

    document.getElementById('forgotLink').addEventListener('click', function (e) {
        e.preventDefault();
        resetEmail.value = emailInput.value;
        switchStep(true);
        resetEmail.focus();
    });

    document.getElementById('resetBack').addEventListener('click', function () {
        switchStep(false);
        emailInput.focus();
    });

    function submitReset() {
        var email = resetEmail.value.trim();
        resetNote.classList.remove('show');
        resetErr.classList.remove('show');

        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
            resetErr.textContent = L.emailInvalid;
            resetErr.classList.add('show');
            return;
        }

        var tokenInput = document.querySelector('input[name="__RequestVerificationToken"]');
        resetSend.disabled = true;
        fetch('/Auth/ResetPassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'RequestVerificationToken': tokenInput ? tokenInput.value : ''
            },
            body: JSON.stringify({ email: email })
        })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            resetSend.disabled = false;
            if (data && data.ok) {
                resetErr.classList.remove('show');
                resetNote.textContent = data.message || L.resetSent;
                resetNote.classList.add('show');
            } else {
                resetErr.textContent = data && data.message ? data.message : L.resetFailed;
                resetErr.classList.add('show');
            }
        })
        .catch(function () {
            resetSend.disabled = false;
            resetErr.textContent = L.resetFailed;
            resetErr.classList.add('show');
        });
    }

    resetSend.addEventListener('click', submitReset);
    resetEmail.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            submitReset();
        }
    });
})();
